import type { Season, WeekDay } from '@bridebook/models/source/models/Weddings.types';

export const WEEK_DAYS: [WeekDay, ...WeekDay[]] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const SEASONS: [Season, ...Season[]] = ['autumn', 'spring', 'summer', 'winter'];
